import { NOTIFY_TTL_MS } from './config';

// server-ops emits notifications but renders nothing and translates nothing
// (03-03 §3): it hands the app a stable message KEY; the app owns the toast UI
// and i18n. The app registers a sink the same way @smartsash/auth registers
// http hooks — until then, notifications are a no-op.

export type NotificationLevel = 'success' | 'error' | 'info';

export interface ServerOpsNotification {
  level: NotificationLevel;
  /** Stable i18n key (from `getErrorMessage`, or a caller-supplied success key). */
  messageKey: string;
  /** Server-provided detail text, if any — not translated. */
  detail?: string;
  /** Auto-dismiss hint (ms); the app may ignore it. */
  ttlMs: number;
}

export type NotificationSink = (notification: ServerOpsNotification) => void;

let sink: NotificationSink | null = null;

/** Wire the app's toast layer. Returns an unsubscribe for teardown/tests. */
export function registerNotificationSink(next: NotificationSink): () => void {
  sink = next;
  return () => {
    if (sink === next) sink = null;
  };
}

/** Test/bootstrap seam. */
export function resetNotificationSink(): void {
  sink = null;
}

export function emitNotification(
  notification: Omit<ServerOpsNotification, 'ttlMs'> & { ttlMs?: number },
): void {
  sink?.({ ttlMs: NOTIFY_TTL_MS, ...notification });
}
